export const ORDERS_FULFILLMENT_GENERIC_ERROR = '1100'
export const ORDERS_CANCEL_ORDER_FULFILLMENT_ERROR = '1101'
export const ORDERS_CANCEL_LINE_ITEM_FULFILLMENT_ERROR = '1102'
export const ORDERS_FULFILLMENT_VARIANT_MISSING_SKU = '1103'
export const ORDERS_FULFILLMENT_SHIPMENT_NOT_EDITABLE = '1105'
export const STRIPE_GENERIC_ERROR = '1300'
export const STRIPE_REFUND_NOT_COMPLETED = '1301'
export const INVALID_TIN_TAX_INFORMATION_ERROR = '1501'
export const INVALID_BIN_TAX_INFORMATION_ERROR = '1502'
